import styled from "@emotion/styled";
import React from "react";
import PbBreadCrumbProps from "./PbBreadCrumbProps.type";
import { defaultFonts } from "../../../helpers/fonts";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";

const BreadcrumbsContainer = styled.div({
  display: "flex",
  flexDirection: "row",
  margin: "12px",
  alignItems: "flex-start",
  justifyContent: "center",
});

const Breadcrumbs = styled.div({
  display: "flex",
  flexDirection: "row"
});

const PathChunk = styled.div({
  fontFamily: defaultFonts,
  paddingRight: "35px",
  margin: "auto 0"
});

const Separator = styled(ArrowDropDownCircleIcon)({
  transform: "rotate(-90deg)",
  color: "yellow",
  borderRadius: "999px",
  backgroundColor: "black",
  marginRight: "35px"
});

const PbBreadCrumb = (props: PbBreadCrumbProps) => {
  const pathChuncks = props.path.split("/");

  const getChunckPath = (index: number) => {
    let regeneratedPath = "";
    for (let i = 0; i < index+1; i++) {
      if (i === index) {
        regeneratedPath = regeneratedPath + pathChuncks[i];
      } else {
        regeneratedPath = regeneratedPath + pathChuncks[i] + "/";
      }
    }
    
    return regeneratedPath;
  };

  return (
    <BreadcrumbsContainer>
      {pathChuncks.map((chunk, index) => {
        return (
          <Breadcrumbs key={`breadcrumb-chunk-${chunk}`}>
            <PathChunk
              onClick={() => {
                props.onLocationClick(getChunckPath(index));
              }}
              id={`breadcrumb-chunk-${chunk}`}
            >
              {chunk}
            </PathChunk>
            {index + 1 !== pathChuncks.length ? <Separator /> : null}
          </Breadcrumbs>
        );
      })}
    </BreadcrumbsContainer>
  );
};

export default PbBreadCrumb;
